import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m3.889 6 5.025-5c.19.082.378.198.562.35.184.15.359.332.524.544L5.84 5.988 10 9.996c-.17.216-.344.407-.524.573-.18.166-.367.31-.562.431L3.889 6z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
